/**
* We want to scroll to the top on every navigation change
*/
export const scrollToTheTopPlease = () => {
  window.scrollTo(0, 0)
  return true
}